export default __webpack_public_path__ + "static/welcome-7a7d983cdc9eb6ff8a87a66bf0558538.jpg";